export class CallableToolKindToken {}
